import easelAPI, { EaselResponse, postOptions } from 'apis/helpers/easelAPI'

type Payload = {
  email: string
  firstName: string
  lastName: string
  company: string
  industry: Array<string>
}

export const postAALanderContact = async (payload: Payload): Promise<EaselResponse> => {
  const options = { ...postOptions, body: JSON.stringify(payload) }
  const json = easelAPI.fetchJSON({
    name: 'postAALanderContact',
    options,
    url: '/art-advisory-lander/contact-us',
  })
  return json
}
